import { ChangeDetectionStrategy, Component } from '@angular/core';

import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-unauthorized',
  imports: [
    RouterModule
],
    templateUrl: './unauthorized.component.html',
    styleUrl: './unauthorized.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnauthorizedComponent {

}
